import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    STATEMENT: {
        id: 'accountTimelineType.STATEMENT',
        defaultMessage: 'Statement',
    },
    TRANSACTION: {
        id: 'accountTimelineType.TRANSACTION',
        defaultMessage: 'Transaction',
    },
    CONFIRMATION: {
        id: 'accountTimelineType.CONFIRMATION',
        defaultMessage: 'Confirmation',
    },
    CASHIN: {
        id: 'accountTimelineType.CASHIN',
        defaultMessage: 'Cash-in',
    },
    CARD: {
        id: 'accountTimelineType.CARD',
        defaultMessage: 'Card',
    },
});

export default enumMessages;
